// @core/api/endpoints/calendar/create_booking_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLinkResponse,
  CreateBookingLinkRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Create booking link
 * Creates a shareable scheduling page that lets external or internal users book time on the owner's calendar.
 */
export async function CreateBookingLink(
  data: CreateBookingLinkRequest,
  options?: RequestOptions
): Promise<BookingLinkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/booking-links`;
  const requestOptions = options;
  return client.post<BookingLinkResponse>(requestPath, data, requestOptions);
}
